import { render, staticRenderFns } from "./MasterDataIndex.vue?vue&type=template&id=948927a0&"
import script from "./MasterDataIndex.vue?vue&type=script&lang=js&"
export * from "./MasterDataIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports